<template>
    <div>
      <div class="d-flex justify-content-between">
        <h1 class="page-header">{{ $t('village.pageTitle') }}</h1>
        <ts-breadcrumb
          :items="[
            { text: $t('home'), href: '/' },
            {
              text: $t('village.pageTitle'),
              active: true
            }
          ]"
        />
      </div>
      <ts-panel>
        <ts-panel-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <div class="d-flex">
              <ts-input
                v-model="search"
                              v-tooltip="$t('village.search')"
                :placeholder="$t('village.search')"
                style="width: 250px;"
                class="inline-block"
              />
            </div>
          </div>
        </ts-panel-wrapper>
        <Table
					:columns="columns"
          :data="villageResources"
          size="small"
          :loading="loading"
          highlight-row
          stripe
          max-height="700"
        >
				  <template slot-scope="{ row }" slot="villageCode">
            <td class="ts-text-blue-500">{{ row.village_code }}</td>
          </template>
          <template slot-scope="{ row }" slot="nameKh">
            <td class="ts-text-blue-500">{{ row.name_kh }}</td>
          </template>
          <template slot-scope="{ row }" slot="nameEn">
            <td class="ts-text-blue-500">{{ row.name_en }}</td>
          </template>
          <template slot-scope="{ row }" slot="action">
            <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(row)"
              >
                <i class="fas fa-edit"></i>
              </a>
          </template>
        </Table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination
            v-model="villagePaginate"
            @navigate="fetchData"
          ></ts-pagination>
        </div>
      </ts-panel>
      <a-modal
        v-if="show_form"
        v-model="show_form"
        :title="!isUpdate ? $t('addNew') : $t('update')"
        :centered="true"
        @cancel="onCancel"
        :footer="null"
      >
        <VillageForm :record="record" @cancel="onCancel" />
      </a-modal>
    </div>
  </template>
  
  <script>
  import { debounce, isEmpty } from 'lodash'
  import { mapState } from 'vuex'
  import VillageForm from './components/village-form.vue'
  export default {
    name: 'branchIndex',
    components: {
      VillageForm
    },
    data() {
      return {
        loading: false,
        show_form: false,
        record: {}
      }
    },
    computed: {
      ...mapState('corporate/address', ['villageResources', 'villagePaginate']),
  
      isUpdate() {
        return !isEmpty(this.record)
      },
      search: {
        get() {
          return this.$store.state.corporate.address.search
        },
        set(newValue) {
          this.$store.commit('corporate/address/SET_SEARCH', newValue)
          this.$store.commit('corporate/address/RESET_CURRENT_PAGE')
        }
      },
      columns() {
        return [
          { 
						title: this.$t('village.provinceNameKh'),
						key: 'p_name_kh' 
					},
          { 
						title: this.$t('village.districtNameKh'),
						key: 'd_name_kh' 
					},
          { 
						title: this.$t('village.districtNameEn'),
						key: 'd_name_en' 
					},
          { 
						title: this.$t('village.communeCode'),
						key: 'commune_code' 
					},
          { 
						title: this.$t('village.communeNameKh'),
						key: 'c_name_kh' 
					},
          { 
						title: this.$t('village.communeNameEn'),
						key: 'c_name_en'
					},
          { 
						title: this.$t('village.villageCode'),
						slot: 'villageCode' 
					},
          { 
						title: this.$t('village.nameKh'),
						slot: 'nameKh' 
					},
          { 
						title: this.$t('village.nameEn'),
						slot: 'nameEn' 
					},
          {
            title: this.$t('actions'),
          	key: 'action',
          	slot: 'action',
          	fixed: 'right',
          	align: 'center',
          	width: 90
          }
        ]
      }
    },
    methods: {
      fetchData(attributes) {
        this.loading = true
        this.$store
          .dispatch('corporate/address/villageFetch', { ...attributes })
          .then(() => {
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$toasted.error(error.message)
          })
      },
      addNew() {
        this.show_form = true
      },
      edit(record) {
        this.record = record
        this.show_form = true
      },
      onCancel() {
        this.show_form = false
        this.record = {}
        this.fetchData()
      }
    },
    watch: {
      search: debounce(function() {
        this.fetchData()
      }, 500)
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.fetchData()
      })
    },
    beforeRouteLeave(to, from, next) {
      this.$store.commit('corporate/address/RESET_STATE')
      next()
    }
  }
  </script>
  